import { render, staticRenderFns } from "./ChallengeUserDetail.vue?vue&type=template&id=6a493eac&"
import script from "./ChallengeUserDetail.vue?vue&type=script&lang=js&"
export * from "./ChallengeUserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports